import * as Yup from "yup";

export const nameValidation = (name, path, allowSpace) =>
  Yup.string()
    .test({
      test: function (value) {
        return /\s/.test(value) && !allowSpace
          ? this.createError({
              message: `${name} should have no space`,
              path,
            })
          : true;
      },
    })
    .test({
      test: function (value) {
        return /\d/.test(value)
          ? this.createError({
              message: "Invalid name",
              path,
            })
          : true;
      },
    })
    .min(3, "Not less than 3 characters")
    .required(`${name} is required`);

const phoneRegExp = /^([0]{1})[0-9]{10}$/;

export const phoneNoValidation = () =>
  Yup.string()
    .matches(phoneRegExp, "Invalid phone number.")
    .required("Phone Number is required");

export const phoneNumberValidation = (name, path, status = true) => {
  //status arg here is to check for function to setValue
  //setFieldValue doesnt count preceeding "0" as a valid number
  //while onChange does. By default, setFieldValues is used
  //so we then check for 10 digits
  let validNum = status ? 10 : 11;

  return Yup.string()
    .min(validNum, "Must be 11 digits")
    .max(validNum, "Must be 11 digits")
    .test({
      test: function (value) {
        return /\s/.test(value)
          ? this.createError({
              message: `${name} should have no space`,
              path,
            })
          : true;
      },
    })
    .test({
      test: function (value) {
        return /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(value) // eslint-disable-line
          ? this.createError({
              message: "Avoid special characters",
              path,
            })
          : true;
      },
    })
    .matches(
      /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/,
      "Enter a valid phone number"
    )
    .required(`${name} is required`);
};

export const passwordValidation = () =>
  Yup.string()
    .required("Password is required")
    .min(12, "Password must not be less than 12 characters")
    .test({
      test: function (value) {
        //eslint-disable-next-line
        return !/[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(value)
          ? this.createError({
              message: "Password must contain at least one special character",
              path: "password",
            })
          : true;
      },
    })

    .test({
      test: function (value) {
        return !/(?=.*[0-9])/.test(value)
          ? this.createError({
              message: "Password must contain at least one number",
              path: "password",
            })
          : true;
      },
    });

export const emailValidation = () =>
  Yup.string().email("Invalid email format!").required("Email is required");

export const defaultValidation = (name) =>
  Yup.string().required(`${name || "This field"} is required`);

export const bvnValidation = () =>
  Yup.string()
    .min(11, "Must be 11 digits")
    .max(11, "Must be 11 digits")
    .required("BVN is required");

export const ninValidation = () =>
  Yup.string()
    .min(11, "Must be 11 digits")
    .max(11, "Must be 11 digits")
    .required("NIN is required");

export const pmPinValidation = () =>
  Yup.string()
    .min(4, "Must be four digits")
    .max(4, "Must be four digits")
    .required("Pin is required");
